import type { EmployeeCheckinData, EmployeeCheckinStatus } from '@/libs/interfaces'
import type { PunchPayload } from '@/services/api/checkIn'

import { mockCheckinStatuses } from '../fixtures/checkIn'
import { mockEmployees } from '../fixtures/seed'
import { delay, nowISO } from '../helpers'
import { createEntityStore } from '../store'

const checkinStatusStore = createEntityStore<EmployeeCheckinStatus, 'employeeID'>(
  mockCheckinStatuses,
  'employeeID',
)

export const checkInApiMock = {
  getcheckInStatus: async (storeID: string): Promise<EmployeeCheckinData> =>
    delay({
      checkinStatuses: checkinStatusStore.find((status) => status.storeID === storeID),
    }),

  checkIn: async (storeID: string, employeeID: string, _payload: PunchPayload): Promise<void> => {
    const employee = mockEmployees.find((item) => item.employeeID === employeeID)
    const existing = checkinStatusStore.getById(employeeID)
    if (existing) {
      checkinStatusStore.update(employeeID, {
        employeeCheckin: nowISO(),
        employeeCheckout: '',
        storeID,
        status: 'checked-in',
      })
    } else {
      checkinStatusStore.insert({
        employeeID,
        employeeCheckin: nowISO(),
        employeeCheckout: '',
        storeID,
        shortUserName: employee?.shortUserName ?? '',
        status: 'checked-in',
      })
    }
    return delay(undefined)
  },
}
